export default "__VITE_ASSET__DYXd1cJQ__"